// extracted by mini-css-extract-plugin
module.exports = {"degree-select-input":"degree-select-input__1uvtB","circle":"circle__1PqC_","checked":"checked__1syav"};